/**
 * マーク・アイコンマスタ画面のアイコン変換情報一覧クラス
 *
 * @export CwsIconConvInfo
 * @class CwsIconConvInfo
 */
export class CwsIconConvInfo {
    constructor(
        public markCode: string,
        public markGroupCode: string,
        public markName: string,
        public markCodeBranch: string,
        public markFileUrl: string,
        public iconList: {
            iconFileName: string,
            iconUrl: string
        }[]
    ) { }
}
